import classNames from 'classnames';
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import withStyles from 'isomorphic-style-loader/withStyles';
import isLoggedIn from '../../helpers/checkAuth';
import messages from '../../routes/quizzes/quizResult/quizResultMessages'; // todo create a separate lang file
import s from './SectionItemNavigationMenu.scss';

import LessonsListItem from '../LessonsListItem/LessonsListItem';
import QuizzesListItem from '../QuizzesListItem/QuizzesListItem';

@injectIntl
@withStyles(s)
@connect(state => ({
  auth: state.auth,
}))
export default class SectionItemNavigationMenu extends React.Component {
  static propTypes = {
    auth: PropTypes.shape({}).isRequired,
    isMenuOpen: PropTypes.bool.isRequired,
    menuAnchorEl: PropTypes.node,
    handleMenuClose: PropTypes.func.isRequired,
    course: PropTypes.object.isRequired, // eslint-disable-line
    currentItemId: PropTypes.string.isRequired, // quiz or lesson id
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    menuAnchorEl: undefined,
  };

  state = {
    currentSectionIndex: _.findIndex(
      _.get(this, 'props.course.sections', []),
      section =>
        !!_.find(
          _.get(section, 'items', []),
          item => _.get(item, 'item._id') === this.props.currentItemId,
        ),
    ),
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.currentItemId !== nextProps.currentItemId) {
      this.setState({
        currentSectionIndex: _.findIndex(
          _.get(nextProps, 'course.sections', []),
          section =>
            !!_.find(
              _.get(section, 'items', []),
              item => _.get(item, 'item._id') === nextProps.currentItemId,
            ),
        ),
      });
    }
  }

  nextSection = () => {
    const { currentSectionIndex } = this.state;
    const { course } = this.props;

    if (currentSectionIndex !== _.get(course, 'sections.length', 0) - 1) {
      this.setState({
        currentSectionIndex: currentSectionIndex + 1,
      });
    }
  };

  prevSection = () => {
    const { currentSectionIndex } = this.state;

    if (currentSectionIndex) {
      this.setState({
        currentSectionIndex: currentSectionIndex - 1,
      });
    }
  };

  renderSection = (section, index) => {
    const { currentSectionIndex } = this.state;
    const {
      course,
      intl: { formatMessage },
      auth,
    } = this.props;
    const completedLessons = formatMessage(messages.completedItemsInSection, {
      completedLessons: section.completedLessons,
      completedQuizzes: section.completedQuizzes,
      totalLessons: section.totalLessons,
      totalQuizzes: section.totalQuizzes,
    });

    return (
      <div key={section._id} className={s.section}>
        <IconButton
          data-test-id="X4OFRW8tkRK8y-LdgBE67"
          onClick={this.prevSection}
          disabled={!index}
        >
          <ChevronLeftIcon />
        </IconButton>
        <div
          className={classNames(s.flex1, s.flex, s.spaceBetween, s.flexStart)}
        >
          <Typography className={s.sectionName}>{section.name}</Typography>
          {isLoggedIn(auth) && (
            <Tooltip title={completedLessons}>
              <Typography className={s.sectionStat}>
                {section.completedLessons + section.completedQuizzes} /{' '}
                {section.totalLessons + section.totalQuizzes}
              </Typography>
            </Tooltip>
          )}
        </div>
        <IconButton
          data-test-id="LRLmjBoPB5JgulnM3zOR7"
          onClick={this.nextSection}
          disabled={
            currentSectionIndex === _.get(course, 'sections.length', 0) - 1
          }
        >
          <ChevronRightIcon />
        </IconButton>
      </div>
    );
  };

  renderItems = section =>
    _(section.items)
      .map(sectionItem => {
        if (sectionItem.itemType === 'Lesson') {
          return (
            <LessonsListItem
              key={`${section._id}_${_.get(sectionItem, 'item._id', '')}`}
              item={_.get(sectionItem, 'item', {})}
              course={this.props.course}
              active={
                _.get(sectionItem, 'item._id') === this.props.currentItemId
              }
              isCompleted={sectionItem.isCompleted}
            />
          );
        }

        if (sectionItem.itemType === 'Quiz') {
          return (
            <QuizzesListItem
              key={`${section._id}_${_.get(sectionItem, 'item._id', '')}`}
              item={_.get(sectionItem, 'item', {})}
              course={this.props.course}
              active={
                _.get(sectionItem, 'item._id') === this.props.currentItemId
              }
              isCompleted={sectionItem.isCompleted}
            />
          );
        }

        return null;
      })
      .value();

  render() {
    const { isMenuOpen, menuAnchorEl, handleMenuClose, course } = this.props;
    const { currentSectionIndex } = this.state;

    return (
      <Popover
        open={isMenuOpen}
        anchorEl={menuAnchorEl}
        anchorReference="anchorEl"
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{ paper: s.popover }}
      >
        <div className={s.popoverContent}>
          {_.get(course, 'sections', []).map((section, index) => (
            <div
              key={section._id}
              className={currentSectionIndex === index ? '' : s.hidden}
            >
              {!course.hideSectionTitle && this.renderSection(section, index)}
              <List component="div" disablePadding className={s.list}>
                {this.renderItems(section)}
              </List>
            </div>
          ))}
        </div>
      </Popover>
    );
  }
}
